// extracted by mini-css-extract-plugin
export default {"Paginate":"Paginate_Paginate__4epRC"};